<template>
  <transition name="fade">
    <v-card class="pa-4 mb-4">
      <v-form @submit.prevent="checkForm">
        <v-text-field
          v-model="editData.Nombre"
          label="Nombre del Hotel"
          readonly
          placeholder="Nombre del Hotel"
        ></v-text-field>

        <v-checkbox
          v-model="transportacionActivada"
          label="Administrar precios de transportación"
        ></v-checkbox>

        <v-container v-if="transportacionActivada">
          <v-select
            v-model="epHotelId"
            :items="hotelesEP"
            item-value="Id"
            item-text="label"
            label="Ubicación de hotel"
            dense
          ></v-select>

          <v-text-field
            v-model.number="PrecioRT"
            label="Precio RoundTrip (USD)"
            type="number"
            @keypress="$pgsHelper.onlyNumber($event, PrecioRT)"
          ></v-text-field>
          <v-text-field
            v-model.number="PrecioOWHG"
            label="Precio One Way (Hotel -> Campo) (USD)"
            type="number"
            @keypress="$pgsHelper.onlyNumber($event, PrecioOWHG)"
          ></v-text-field>
          <v-text-field
            v-model.number="PrecioOWGH"
            label="Precio One Way (Campo -> Hotel) (USD)"
            type="number"
            @keypress="$pgsHelper.onlyNumber($event, PrecioOWGH)"
          ></v-text-field>
        </v-container>

        <v-text-field
          v-model="duracion"
          label="Duración del viaje hasta el campo de golf (Horas)"
          placeholder="Duración de viaje"
          type="text"
          :error-messages="errors.duracion"
        ></v-text-field>

        <v-row justify="end">
          <v-btn class="mr-2" @click="$emit('toggle', false)"
            >Cancelar</v-btn
          >
          <v-btn color="success" type="submit">Guardar</v-btn>
        </v-row>
      </v-form>
    </v-card>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import axiosCore from "axios";
export default {
  name: "precioTransForm",
  components: {},
  props: ["editData"],
  data() {
    return {
      Id: "",
      nombre: "",
      codigo: "",
      ruta: "",
      transportacionActivada: false,
      epHotelId: "",
      PrecioRT: "",
      PrecioOWGH: "",
      PrecioOWHG: "",
      duracion: "",
      errors: {},
      hotelesEP: [],
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (this.transportacionActivada == true) {
        if (
          this.PrecioRT === "" ||
          this.PrecioOWGH === "" ||
          this.PrecioOWHG === ""
        ) {
          this.errors.duracion = "Proporciona precios validos";
          valid = false;
        } else {
          this.errors.duracion = false;
        }
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        //let data_hotel = this.hoteles[this.index_hotel];
        this.$emit("successData", this.$data);
      }
    },
    async getEpHotel() {
      let axiosInstance = axiosCore.create({
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: (data) => {
          return JSON.stringify(data);
        },
      });
      let urlEp =
        "https://www.entertainment-plus.net/get_hotels_deeplink?term=" +
        this.editData.Nombre;
      this.$pgsHelper.log(urlEp);
      const response = await axiosInstance.get(urlEp);
      this.hotelesEP = response.data;
    },
  },
  computed: {},
  watch: {
    editData: function () {
      this.getEpHotel();
    },
  },
  beforeMount: function () {},
  mounted() {
    this.getEpHotel();
    this.$pgsHelper.log(this.editData);
    this.Id = this.editData.id;
    this.epHotelId = this.editData.Transportacion
      ? this.editData.Transportacion.ExtraParams.EpHotelId
      : "";
    this.PrecioRT = this.editData.Transportacion
      ? this.editData.Transportacion.PrecioRT
      : "";
    this.PrecioOWGH = this.editData.Transportacion
      ? this.editData.Transportacion.PrecioOWGH
      : "";
    this.PrecioOWHG = this.editData.Transportacion
      ? this.editData.Transportacion.PrecioOWHG
      : "";
    this.transportacionActivada = this.editData.ActiTrans;
    this.duracion = this.editData.Transportacion
      ? this.editData.Transportacion.DuracionViaje
      : "";
  },
};
</script>
